module.exports = __webpack_public_path__ + "img/logout.00faeff5.svg";